import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useEffect, useRef } from "react";
import EventPageTitle from "./components/EventPageTitle";
import RecentActivitiesFilters from "./components/RecentActivitiesFilters";
import EventTableContainer from "./components/table/EventTableContainer";

const RecentActivitiesPage = () => {
  const refreshTimerRef = useRef<number | null>(null);

  useEffect(() => {
    const start = () => {
      if (refreshTimerRef.current) return;

      refreshTimerRef.current = window.setInterval(() => {
        const isMediaOpen = document.querySelector(
          ".MuiDialog-root, .MuiModal-root, video[controls]"
        );

        if (!isMediaOpen) {
          window.location.reload();
        }
      }, 2 * 60 * 1000); // 2 minutes auto refresh
    };

    const stop = () => {
      if (refreshTimerRef.current) {
        clearInterval(refreshTimerRef.current);

        refreshTimerRef.current = null;
      }
    };

    start();

    return () => {
      stop();
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1em",
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <EventPageTitle title="Control room" />
        </Grid>

        <RecentActivitiesFilters />
      </Grid>

      <EventTableContainer />
    </Box>
  );
};

export default RecentActivitiesPage;
